import { render } from "./addAccountManage.vue?vue&type=template&id=5e1f2f88&scoped=true"
import script from "./addAccountManage.vue?vue&type=script&lang=js"
export * from "./addAccountManage.vue?vue&type=script&lang=js"

import "./addAccountManage.vue?vue&type=style&index=0&id=5e1f2f88&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1f2f88"]])

export default __exports__